<div class='floating-resultat'>
  <div>Zone 1 : {{ measuresZone1$ | async | json}}</div>
  <div>Zone 2 : {{ measuresZone2$ | async | json}}</div>
  <div>Zone 3 : {{ measuresZone3$ | async | json}}</div>
  <div>Coordonnées : {{ gpsData$ | async | json}}</div>
  <div>Distance : {{ distance$ | async | json}}</div>
</div>
